<app-live-course-header></app-live-course-header>

<div class="courses-main-div common-gradiant">
    <div class="container">
        <div class="courses-content-main-div">
            <div class="course-about">
                <div class="course-title">
                    <h1>Mastering Data Structures & Algorithms: Problem-Solving for the Real World</h1>
                    <p>Master Data Structures & Algorithms with expert-led training, hands-on coding practice, and
                        coding bootcamps.</p>
                </div>
                <div class="banner-sup-text">
                    <div style="display: flex;">
                        <img src="../../../assets/img/live-courses/academic.svg" alt="">
                        <p>Build a strong foundation in Data Structures and Algorithms</p>
                    </div>
                    <div style="display: flex;">
                        <img src="../../../assets/img/live-courses/settigs.svg" alt="">
                        <p>Connect with top professionals from Industry to understand real-life use case</p>
                    </div>
                    <div style="display: flex;">
                        <img src="../../../assets/img/live-courses/chart.svg" alt="">
                        <p>Get access to platform for coding practice, MCQs, and interview preparation</p>
                    </div>
                    <div style="display: flex;">
                        <img src="../../../assets/img/live-courses/language-img-icon.svg" alt="">
                        <p>Regular doubt-solving sessions to clarify concepts and improve coding skills</p>
                    </div>
                    <div style="display: flex;">
                        <img src="../../../assets/img/live-courses/language-img-icon.svg" alt="">
                        <p>Earn a certification and exciting rewards upon successful course completion</p>
                    </div>

                </div>
                <div class="course-class-mode">
                    <label for="" class="text-change-animation">{{classFeature}}</label>
                </div>

                <a href="https://rzp.io/rzp/campus-program-dsa" target="_blank">
                    <button type="button" class="btn course-banner-button">
                        <span> Register Now</span></button>
                </a>
            </div>

            <div class="banner-img">
                <img src="../../../assets/img/live-courses/hero-section-banner.png" alt="banner">
            </div>

        </div>
        <div class="information-card">
            <div class="info-card-content">
                <div class="achived-out-card-image-one" style="background-color: #17B3FC33;">
                    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M40.5 7.5H7.5C6.70435 7.5 5.94129 7.81607 5.37868 8.37868C4.81607 8.94129 4.5 9.70435 4.5 10.5V37.5C4.5 38.2956 4.81607 39.0587 5.37868 39.6213C5.94129 40.1839 6.70435 40.5 7.5 40.5H10.0106C10.2945 40.5001 10.5726 40.4196 10.8126 40.2679C11.0525 40.1163 11.2445 39.8996 11.3663 39.6431C12.0957 38.1031 13.2473 36.8019 14.6871 35.8906C16.127 34.9794 17.796 34.4957 19.5 34.4957C21.204 34.4957 22.873 34.9794 24.3129 35.8906C25.7527 36.8019 26.9043 38.1031 27.6338 39.6431C27.7555 39.8996 27.9475 40.1163 28.1874 40.2679C28.4274 40.4196 28.7055 40.5001 28.9894 40.5H40.5C41.2957 40.5 42.0587 40.1839 42.6213 39.6213C43.1839 39.0587 43.5 38.2956 43.5 37.5V10.5C43.5 9.70435 43.1839 8.94129 42.6213 8.37868C42.0587 7.81607 41.2957 7.5 40.5 7.5ZM19.5 31.5C18.3133 31.5 17.1533 31.1481 16.1666 30.4888C15.1799 29.8295 14.4108 28.8925 13.9567 27.7961C13.5026 26.6997 13.3838 25.4933 13.6153 24.3295C13.8468 23.1656 14.4182 22.0965 15.2574 21.2574C16.0965 20.4182 17.1656 19.8468 18.3295 19.6153C19.4933 19.3838 20.6997 19.5026 21.7961 19.9567C22.8925 20.4108 23.8295 21.1799 24.4888 22.1666C25.1481 23.1533 25.5 24.3133 25.5 25.5C25.5 27.0913 24.8679 28.6174 23.7426 29.7426C22.6174 30.8679 21.0913 31.5 19.5 31.5ZM40.5 37.5H29.8931C29.239 36.3726 28.4056 35.3594 27.4256 34.5H36C36.3978 34.5 36.7794 34.342 37.0607 34.0607C37.342 33.7794 37.5 33.3978 37.5 33V15C37.5 14.6022 37.342 14.2206 37.0607 13.9393C36.7794 13.658 36.3978 13.5 36 13.5H12C11.6022 13.5 11.2206 13.658 10.9393 13.9393C10.658 14.2206 10.5 14.6022 10.5 15V33C10.4998 33.3327 10.6103 33.656 10.8139 33.919C11.0176 34.1821 11.3029 34.37 11.625 34.4531C10.6222 35.3218 9.7712 36.3516 9.10687 37.5H7.5V10.5H40.5V37.5Z"
                            fill="#17B3FC" />
                    </svg>

                </div>
                <div class="achived-out-card-text-four">
                    <span>Live</span>
                    <p>Interactive Sessions</p>
                </div>
            </div>

            <div class="info-card-content">
                <div class="achived-out-card-image-one" style="background-color: #FFA41B33;">
                    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M42.9211 17.613C44.3596 18.0508 44.3596 19.9896 42.9211 20.4274L25.4699 25.8059C24.2189 26.1811 23.093 25.9935 22.5302 25.8059L10.3331 22.0534C9.51994 22.5537 9.0821 23.4293 9.01955 24.3674C9.58249 24.6801 10.0203 25.3055 10.0203 25.9935C10.0203 26.6814 9.64504 27.2443 9.14465 27.6195L10.7084 34.8116C10.8335 35.4372 10.3956 36 9.77014 36H6.20485C5.57936 36 5.14152 35.4372 5.26662 34.8116L6.83034 27.6195C6.32995 27.2443 6.0172 26.6814 6.0172 25.9935C6.0172 25.3055 6.3925 24.6801 7.01799 24.3049C7.08053 23.2417 7.45583 22.1785 8.14387 21.3655L5.07897 20.4274C3.64034 19.9896 3.64034 18.0508 5.07897 17.613L22.5302 12.2345C23.4683 11.9218 24.5317 11.9218 25.4699 12.2345L42.9211 17.613ZM26.0329 27.7446L35.1024 24.9303L36.0407 31.9974C36.0407 34.2489 30.6615 36 24.0313 36C17.3386 36 12.0219 34.2489 12.0219 31.9974L12.8976 24.9303L21.9671 27.7446C22.7177 27.9948 24.2815 28.245 26.0329 27.7446Z"
                            fill="#FFA41B" />
                    </svg>

                </div>
                <div class="achived-out-card-text-two">
                    <span>10000+</span>
                    <p>Careers Transformed</p>
                </div>
            </div>
            <div class="info-card-content">
                <div class="achived-out-card-image-one">
                    <i class="fa-solid fa-chalkboard-user" style="color: #27b94e; font-size: 20px;"></i>
                </div>
                <div class="achived-out-card-text-one">
                    <span style="color: #27b94e;">100+</span>
                    <p>Top Industry Mentors</p>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="why-choose-us" style="margin-top: 100px;">
    <app-why-choose-us [link]="'https://rzp.io/rzp/campus-program-dsa'"></app-why-choose-us>
</div>

<div class="course-topic-description common-gradiant ">
    <div class="container">
        <div class="road-map-text">
            <label for="">A Roadmap For Sucess</label>
            <p>Our Comprehensive curriculum, Designed for professionals</p>
        </div>
        <div class="course-description">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <label for="">Course Description</label>
                    <p class="course_desc_main">Master Data Structures and Algorithms (DSA) from scratch in this
                        structured 6-week program designed for college students.
                        Start with the fundamentals and progress to advanced problem-solving techniques, including
                        real-world applications. Learn from industry experts,
                        practice coding on our dedicated platform with handpicked problems. Get ready to excel in coding
                        interviews and build a
                        strong foundation for your tech career.</p>
                    <div class="module-name-card">
                        <ng-container *ngFor="let item of moduleArray;let i = index;">
                            <div class="course-topic-title" (click)="toggleCourseTitle(item,i)"
                                [ngStyle]="item.active == true? {'border-bottom':'none','background-color':'var(--mainColor)','color':'#fff','border-bottom-right-radius':'0px','border-bottom-left-radius':'0px'}:{}">

                                <div>
                                    <span class="topicname">Module {{i+1}} -
                                        {{item.courseTopic}} <span
                                            *ngIf="item.timeTaking">({{item.timeTaking}})</span></span>
                                </div>
                                <div>

                                    <img class="project-icon-img"
                                        *ngIf="item.isProjectInclude == true  && item.active == false"
                                        src="../../../assets/img/courses/icon/project-icon.png" alt="">
                                    <img class="project-icon-img"
                                        *ngIf="item.isProjectInclude == true && item.active == true"
                                        src="../../../assets/img/courses/icon/project-icon-in-white.png" alt="">
                                    <i [ngStyle]="item.active == false? {'color': '#000'}:{}"
                                        *ngIf="item.active == false" class="fa-solid fa-plus"></i>
                                    <i [ngStyle]="item.active == true? {'color': '#fff'}:{}" *ngIf="item.active == true"
                                        class="fa-solid fa-minus"></i>

                                </div>

                            </div>

                            <ng-container *ngIf="item.active == true">
                                <div class="course-details" *ngFor="let child of item.childProperties">
                                    <div class="module-description-main-div">
                                        <div class="about-module">
                                            <p>{{child.module_description}}</p>
                                        </div>
                                        <div class="module-key-hold">
                                            <ul *ngFor="let key of child.moduleContant">
                                                <i class="fa-solid fa-circle-check"></i>{{key}}
                                            </ul>
                                        </div>
                                        <div class="project module-key-hold">
                                            <i class="fa-solid fa-circle-right" *ngIf=" child.project.length"></i><span
                                                *ngIf=" child.project.length"
                                                style="font-size: 20px; font-weight: 500;">
                                                Problem Solving:
                                            </span>
                                            <ul *ngFor="let project of child.project" style=" margin-top: 10px; ">
                                                <li *ngIf="project?.title != ''"
                                                    style="list-style: none;font-size: 20px; font-weight: 500;"><i
                                                        class="fa-solid fa-arrow-right"></i> {{project?.title}}</li>
                                                <ul *ngFor="let projectChild of project.pType"
                                                    style="list-style: none; margin-top: 10px;"> <i
                                                        class="fa-solid fa-circle-check"></i>{{projectChild}}</ul>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="mentor-section common-gradient">
    <div class="container">
        <!-- Left Content -->
        <div class="left-content">
            <h2>Learn with Industry Experienced Mentor</h2>
            <p class="description">
                Get personalized guidance from our expert mentor, who has transformed the careers of over 5,000+
                students. Currently working as a Senior Software Engineer at Oracle Cloud Infrastructure, he brings
                real-world insights from his experience at top tech companies like Goldman Sachs, PayPal, and ADP. With
                extensive experience in high-scale system design and 5+ years of teaching, he is dedicated to making
                complex concepts easy to understand and helping you achieve your career goals.
            </p>

            <div class="stats-container">
                <div *ngFor="let stat of stats" class="stat-card">
                    <strong>{{ stat.value }}</strong>
                    <p>{{ stat.label }}</p>
                </div>
            </div>
        </div>

        <!-- Right Content -->
        <div class="right-content">
            <div class="mentor-card">
                <img [src]="mentor.image" alt="{{ mentor.name }}" class="mentor-image" />
                <h3>{{ mentor.name }}</h3>
                <p class="mentor-title">{{ mentor.title }}</p>
                <p class="mentor-title" style="margin-top: -20px;">{{ mentor.title2 }}</p>
                <a [href]="mentor.linkedinUrl" target="_blank" class="linkedin-button">
                    <img src="assets/img/ldn-white.png" alt="LinkedIn" class="linkedin-icon" />
                    Connect on LinkedIn
                </a>
            </div>
        </div>
    </div>
</div>
<div>
    <app-certification [certificateImage]="certificateImage" [link]="'https://rzp.io/rzp/campus-program-dsa'"></app-certification>
</div>

<div class="common-gradiant">
    <div class="courses-highlights_courses_fee_div container">

        <div class="course-highlight">
            <div class="course-highlight-content">
                <h6> <span style="color: #000;">Course</span> Highlight</h6>
                <li><img src="../../../assets/img/courses/icon/telivision.png" alt="logo"><span>30+ Live
                        Sessions</span>- Learn
                    directly from industry experts.
                </li>
                <li><img src="../../../assets/img/courses/icon/industry-project.png" alt="logo"><span>Access to LMS
                    Platform</span>- Get access to AlgoTutor platform for interview preparation</li>
                <li><img src="../../../assets/img/courses/icon/clock.png" alt="logo"><span>Class Recording
                        Access</span>-
                    Revisit
                    course materials anytime, anywhere.
                </li>
                <li><img style="height: 25px;" src="../../../assets/img/live-courses/certificate_icon.png" alt="logo">
                    <span>Certification & Rewards</span>- Get certified and rewards on course completion.
                </li>
            </div>
        </div>


        <div class="course-fee">
            <div class="courses-fee-content">
                <h6>Program Fee</h6>
                <!-- <p>We are driven by the idea of program affordability. So, we give you several financial options
                    to manage
                    and budget the expenses of your course.</p> -->

                <div class="fee_payment desktop">
                    <div class="payment">
                        <div class="fee">
                            <p style="font-size: 18px; color: #000;">Actual Fee: <del style="color: #007bff; font-weight: 600;"> ₹9500</del></p>
                            <b style="margin-top: -10px;">₹ 3800 <span>(including taxes)</span></b>
                        </div>

                        <div class="commnts">
                            <p><i class="fa fa-solid fa-check"></i> Affordable & Flexible Payments</p>
                        </div>
                    </div>

                    <div class="enroll-now-button">
                        <a target="_blank" href="https://rzp.io/rzp/campus-program-dsa"><span
                                class="enroll-btn">Register Now</span></a>
                    </div>

                    <div class="rezor-pay-image"><span>Powered by</span><img
                            src="../../../assets/img/razorpay-logo-removebg-preview.png" alt=""></div>
                </div>
             
            </div>
        </div>
    </div>
</div>

<div class="common-gradiant">
    <div class="next-cohort-details container">
        <div class="next-cohort-details-title">
            <h2>Training Schedule Details</h2>
        </div>


        <div class="next-cohort-details-content">
            <div class="row enroll-now">
                <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                    <div>
                        <label for="">2 <span class="th-class">nd</span> </label>
                        <label class="month-name">Jun <span style="font-size: 16px;">(Tentative)</span></label>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                    <strong>Weekday Batch [Mon - Fri]</strong>
                </div>
            </div>

            <div class="batch-details">
                <div>
                    <label for="">Batch</label>
                    <p>Evening</p>
                </div>
                <div>
                    <label for="">Class Duration</label>
                    <p>2 Hours</p>
                </div>
                <div>
                    <label for="">Class Timing</label>
                    <p>6PM - 8PM</p>
                </div>
                <div>
                    <label for="">Course Duration</label>
                    <p>6 Weeks</p>
                </div>
                <div>
                    <label for="">Mode</label>
                    <p>Online</p>
                </div>
            </div>
        </div>


    </div>
</div>

<div class="common-gradiant" style="padding-bottom: 50px; padding-top: 20px; margin-top: 50px;">
    <app-live-course-faq></app-live-course-faq>
</div>
